<!--
create by melody on 2018/11/1
description:科目规则维护配置页面
-->
<template>
	<div>
		<page-header :title="title"></page-header>
        <div class="search-container hdp-w-100">
            <div class="hdp-uf hdp-w-100">
                <div class="hdp-uf hdp-uf-vc">{{$t('m.primaryLedger')}}：</div>
                <el-select filterable v-model="searchParam.primaryLedger" @change="getDemoList()" style="width:25%;margin-left:10px;margin-right:5%;">
                    <el-option v-for="(item, index) in accountList" :key="index" :label="item.label" :value="item.label"></el-option>
                </el-select>
                <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
            </div>
        </div>
		<div class="table-container">
            <div class="hdp-uf hdp-w-100" style="margin-bottom: 20px">
                <div class="hdp-uf hdp-uf-vc">{{$t('m.documentType')}}：</div>
                <el-select filterable v-model="searchParam.documentType" @change="getDemoList()" style="width:25%;margin-left:10px;">
                    <el-option v-for="(item, index) in documentTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
			<!-- <el-form ref="form" label-width="75px">
				<el-row style="width:100%;">
					<el-col :span="6" style="width:30%;">
						<el-form-item label="凭证场景类型:" label-width="120px">
							<el-select v-model="searchParam.documentType" @change="getDemoList()" style="width:90%;">
								<el-option v-for="(item, index) in documentTypeList" :key="index" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form> -->

			<el-tabs type="border-card" v-model="searchParam.titleType" @tab-click="handleTabClick">
				<el-tab-pane v-for="(item, index) in titileTypeList" :key="index" :label="item.label" :name="item.value">
				</el-tab-pane>
				<div class="">
					<el-button type="primary" icon="el-icon-plus" plain @click="handleClick('add')"> {{$t('m.add')}} </el-button>
					<el-button type="info" icon="el-icon-delete" plain @click="handleDelete('batch')"> {{$t('m.delete')}} </el-button>
                    <el-button type="primary" icon="el-icon-plus" plain style="margin-left:30px;" @click="handleColumn('addColumn')"> {{$t('m.addColumn')}} </el-button>
                    <el-button type="info" icon="el-icon-delete" plain @click="handleColumn('deleteColumn')"> {{$t('m.deleteColumn')}} </el-button>
					<el-table ref="multipleTable" :data="tableData" stripe tooltip-effect="dark" style="width: 100%;margin: 24px 0" @select="handleSelect" @select-all="handleSelect">
						<el-table-column type="selection" width="35"></el-table-column>
						<el-table-column type="index"></el-table-column>
						<el-table-column :label="$t('m.contentName')">
							<template slot-scope="scope">{{$commonFunc.alterValue(scope.row.contentName, subentryLineList)}}</template>
						</el-table-column>
                        <el-table-column prop="dcDirection" :label="$t('m.dcDirection')"></el-table-column>
						<el-table-column prop="titleStage" :label="$t('m.titleStage')"></el-table-column>
                        <el-table-column
                            v-if="tableColumnList.length"
                            :label="$t('m.customColumn')">
                            <el-table-column
                                v-for="(item, index) in tableColumnList"
                                :key="index"
                                :prop="item.accountTitleRowName"
                                :label="item.accountTitleRowName">
                            </el-table-column>
                        </el-table-column>
						<el-table-column :label="$t('m.operation')" align="right" width="150">
							<template slot-scope="scope">
								<el-button icon="el-icon-edit-outline" size='mini' plain @click="handleClick('modify', scope.row)"></el-button>
								<el-button type="danger" icon="el-icon-delete" size='mini' plain @click="handleDelete('single', scope.row)"></el-button>
							</template>
						</el-table-column>
					</el-table>
					<lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
				</div>
			</el-tabs>
		</div>
		<!-- add Form -->
		<el-dialog
			:title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
			:visible.sync="dialogVisible"
			v-if="dialogVisible"
			width="30%">
			<div style="margin-left: 10%">
				<el-form ref="form" :model="form" :rules="rules" label-width="140px">
					<el-form-item :label="$t('m.contentName')" prop="contentName" >
                        <el-select v-model="form.contentName" style="width:80%;">
                            <el-option v-for="(item, index) in subentryLineList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
					</el-form-item>
                    <el-form-item :label="$t('m.dcDirection')" prop="dcDirection">
                        <el-select v-model="form.dcDirection" style="width:80%;">
                            <el-option :label="$t('m.directionBorrow')" value="借"></el-option>
                            <el-option :label="$t('m.directionLoan')" value="贷"></el-option>
                        </el-select>
                    </el-form-item>
					<el-form-item :label="$t('m.titleStage')" prop="titleStage">
						<el-input v-model.trim="form.titleStage" :maxlength="$inputLengthObj.maxLength5" style="width:80%;"></el-input>
					</el-form-item>
                    <el-form-item v-for="(item, index) in form.data" :key="index" :label="item.accountTitleRowName" :prop="item.accountTitleRowId">
                        <el-input v-model.trim="item.accountTitleLineValue" :maxlength="$inputLengthObj.maxLength1" style="width:80%;"></el-input>
                    </el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
				<el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
			</div>
		</el-dialog>
        <el-dialog 
            :title="handleColumnType=='addColumn' ? $t('m.addColumn') : $t('m.deleteColumn')" 
            :visible.sync="dialogColumnVisible"
            width="30%">
            <div style="margin-left: 10%">
                <el-form>
                    <el-form-item v-if="handleColumnType=='addColumn'" :label="$t('m.columnName')">
                        <el-input v-model.trim="columnValue" :maxlength="$inputLengthObj.maxLength1" style="width:50%;"></el-input>
                    </el-form-item>
                    <el-form-item v-else-if="handleColumnType=='deleteColumn'" :label="$t('m.columnName')">
                        <el-select v-model="columnValue" style="width:50%;">
                            <el-option v-for="(item,index) in tableColumnList" :key="index" :label="item.accountTitleRowName" :value="item.accountTitleRowId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogColumnVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" @click="handleColumnSave(handleColumnType)">{{$t('m.sure')}}</el-button>
            </div>
        </el-dialog>
	</div>
</template>
<script>
import {mapState,mapGetters} from 'vuex'
export default {
	data () {
		return {
			title: {
				firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.CONFIG_MANAGE'),
                thirdTitle: this.$t('m.ACCOUNT_RULE')
			},
			accountList: [],
			documentTypeList: [],
			titileTypeList: [],
            subentryLineList: [],
			searchParam: {      //查询参数
                primaryLedger: '', //主账套
                documentType: '租赁负债',	//凭证类型
                titleType: '新增',		//科目类型
                pageSize: 10,
                pageNum: 1,
            },
			form: {     //弹框内容
            },
            rules: this.$ruleApi.getRule('accountRule'),
            tableData: [],  //表数据
            total: 0,   //总数
            dialogVisible: false,   //控制弹框显示与隐藏
            dialogColumnVisible: false,
			operateType: '',    //操作类型 add新增 modify修改 view查看
            handleColumnType: '', //addColumn新增列 deleteColumn删除列
            columnValue: '',
            tableColumnList: [],
			deleteDemoIdArr: [],
            addDisable: false
		}
	},
	methods: {
        handleColumn(type) {
            this.columnValue = ''
            this.handleColumnType = type
            if(type == 'addColumn' && this.tableColumnList.length>=9) {
                this.$message.info(this.$t('m.customColumnMax'))
                return
            }
            this.dialogColumnVisible = true
        },
		handleTabClick(tab, event) {
            if(!this.searchParam.primaryLedger) {
                this.$message.info(this.$t('m.chooseLedger'))
            } else {
                this.getDemoList()
            }
	    },
		//获得主账套列表
        getAccountList(code) {
            this.$commonFunc.commonRequest('get', '/configValuesetLine/query/contentList', 'getValueSetLineByCode', {valuesetCode: code})
            .then(res=>{
                res.obj.forEach((o,i)=>{
                    this.accountList.push({label:o.valuesetLineContent, value:o.valuesetLineId})
                })
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        getColumnList() {
            this.$commonFunc.commonRequest('get', '/config/account_title_row/list')
            .then(res=>{
                this.tableColumnList = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
		getDemoList() {
            this.getColumnList()
            this.$commonFunc.commonRequest('get', '/config/accounting_title/getConfigAccountingTitleList', 'getAccountRuleList', this.searchParam)
            .then(res=>{
                this.tableData = []
                this.total = res.obj.total
                if(res.obj.total) {
                    let cur = res.obj.list
                    for (let i = 0; i < cur.length; i++) {
                        let obj = {}
                        obj.accountTitleId = cur[i].accountTitleId
                        obj.contentName = cur[i].contentName
                        obj.dcDirection = cur[i].dcDirection
                        obj.titleStage = cur[i].titleStage
                        if(cur[i].data.length) {
                            cur[i].data.forEach((o, i) => {
                                obj[o.accountTitleRowName] = o.accountTitleLineValue
                            })
                        }
                        this.tableData.push(obj)
                    }
                } else {
                    this.tableData = []
                }
                
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        viewDemo(row) {
            this.$commonFunc.commonRequest('get', '/config/accounting_title/query', 'viewAccountRule', {accountTitleId: row.accountTitleId})
            .then(res=>{
                this.form = res.obj
                this.dialogVisible = true
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.form.data.forEach((o,i)=>{
                delete o['accountTitleRowName']
            })
            this.$commonFunc.commonRequest('post', '/config/accounting_title/addConfigAccountingTitle', 'addAccountRule', this.form, true)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'))
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
             this.form.data.forEach((o,i)=>{
                delete o['accountTitleRowName']
            })
            this.$commonFunc.commonRequest('post', '/config/accounting_title/updateConfigAccountingTitle', 'modifyAccountRule', this.form, true)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'))
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addColumn() {
            this.$commonFunc.commonRequest('post', '/config/account_title_row/added', 'addAccountRuleColumn', {accountTitleRowName: this.columnValue})
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'))
                this.dialogColumnVisible = false
                this.getColumnList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        deleteColumn() {
            this.$commonFunc.commonRequest('get', '/config/account_title_row/deleted', 'deleteAccountRuleColumn', {accountTitleRowId: this.columnValue})
            .then(res=>{
                this.$message.success(this.$t('m.deleteSuccess'))
                this.dialogColumnVisible = false
                this.getColumnList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        handleColumnSave(type) {
            if(type == 'addColumn') {
                this.addColumn()
            } else {
                this.deleteColumn()
            }

        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
        	if (type == 'add') {
        		if(!this.searchParam.primaryLedger) {
        			this.$message.info(this.$t('m.chooseLedger'))
        			return
        		}
        	}
            this.operateType = type
            this.dialogVisible = true
            //如果操作已有数据
            if(row) {
                this.viewDemo(row)
            	// this.form = JSON.parse(JSON.stringify(row))
            } else {
                this.form = {
	                titleType: this.searchParam.titleType,
	                primaryLedger: this.searchParam.primaryLedger,
	                documentType: this.searchParam.documentType,
	                contentName: '',
	                titleStage: '',
	                dcDirection: '',
                    data: this.tableColumnList
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
        	if( type == 'batch' && this.deleteDemoIdArr.length == 0) {
                this.$message.info(this.$t('m.chooseDelete'))
                return 
            }
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                let demoIds = []
                if (type == 'single') {
                    demoIds.push(row.accountTitleId)
                } else {
                	demoIds = this.deleteDemoIdArr
                }
                this.$commonFunc.commonRequest('post', '/config/accounting_title/deleteConfigAccountingTitle', 'deleteAccountRule', {accountingTitleIds: demoIds})
                .then(res=>{
                	this.$message.success(this.$t('m.deleteSuccess'))
                	this.deleteDemoIdArr = []
                	this.getDemoList()
                })
                .catch(res=>{
                	this.$message.error(res.message)
                })
            })
        },
		//处理单选
        handleSelect(row) {
            this.deleteDemoIdArr = []
            if(row.length) {
                for(var i = 0; i < row.length; i++) {
                    this.deleteDemoIdArr.push(row[i].accountTitleId)
                }
            }
        }
	},
	async mounted() {
		this.accountList = await this.$commonFunc.getValueSetList(this.$valueSetObj.MAIN_ACCOUNT)
		// this.documentTypeList = await this.$commonFunc.getDataDicList(this.$dataDicObj.DOCUMENT_TYPE)
		// this.titileTypeList = await this.$commonFunc.getDataDicList(this.$dataDicObj.SUBJECT_TYPE)
        // this.subentryLineList = await this.$commonFunc.getDataDicList(this.$dataDicObj.SUBENTRY_LINE_TYPE)
        this.documentTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.documentTypeValueset')], true)
        this.titileTypeList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.titileTypeValueset')], true)
        // this.subentryLineList = await this.$commonFunc.getValueSetList(this.$valueSetObj[this.$t('m.subentryLineValueset')], true)
        this.subentryLineList = await this.$commonFunc.getValueSetList(this.$valueSetObj.SUBENTRY_LINE_TYPE, true)
        this.getColumnList()
	}
}
</script>
<style scoped>
.search-container {
	background: #ffffff;
    padding: 20px;
	/* padding: 10px 0 2px; */
}
.el-select {
    width: 300px;
}
.table-container {
	padding: 24px;
	margin: 32px 0;
	background: #ffffff;
}
.block {
	text-align: right;
}
.el-form-item .el-form-item__content {
	margin-left: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/config/AccountRule.vue